import {observer} from "mobx-react";
import {CircularProgress, Input, Zoom} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React, {useEffect, useState} from "react";
import {useStores} from "../../../Hooks";
import SearchDialog from "./SearchDialog";
import SearchIcon from '@mui/icons-material/Search';
import ConditionalComponent from "../ConditionalComponent";
import {AiButton} from "../../Modals/AiChat/AiButton";
import Utility from "../../../Utility";

const SearchInput = observer(({}) => {
    const {generalStore} = useStores();
    const [openSearch, setOpenSearch] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [acceptableRoles, setAcceptableRoles] = useState([]);
    const isMobile = Utility.isMobile()
    const handleOpen = async () => {
        setOpenSearch(true);
        await getAccess()
    };

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleClose = async () => {
        setOpenSearch(false);
        await cleanCache();
    };

    const getAccess = async () => {
        setIsLoading(true);
        const answer = await generalStore.globalSearchAccess();
        setAcceptableRoles(answer.roles);
        setIsLoading(false);
    }

    const cleanCache = async () => {
        setIsLoading(true);
        await generalStore.globalSearchCleanCache();
        setIsLoading(false);
    }


    return (<div className={`rounded-input bg-nav-normal min-w-18 max-w-100 h-8 pl-2 text-main-hover flex flex-row ${isMobile ? '': 'ml-28'}`} style={{fontSize:'18px', letterSpacing: '1px', width:`${windowWidth/4.8}px`}}>
                <div onClick={handleOpen} className={`flex flex-row items-center h-full w-full cursor-normal  font-normal justify-between pr-4 py-1`}>
                    <ConditionalComponent if={!isMobile}>
                        <div className="pl-3">SEARCH</div>
                    </ConditionalComponent>
                    <SearchIcon style={{fontWeight: '400', color: 'var(--main-normal-color)'}}/>
                </div>
                <AiButton/>
                <Dialog
                        open={openSearch}
                        className="search-global-input"
                        onClose={handleClose}
                        fullWidth
                        maxWidth="sm"
                        TransitionComponent={Zoom}
                        PaperProps={{
                            style: {
                                minHeight: 650,
                                maxHeight: 650,
                                minWidth: 650,
                            },
                        }}
                    > {isLoading
                        ?
                        (<div className="search-global-input-centerContent">
                            <CircularProgress
                                className="search-global-input-progress"/>
                        </div>)
                        :
                        (<SearchDialog
                            handleClose={handleClose}
                            acceptableRoles={acceptableRoles}
                        />)
                    }
                    </Dialog>
    </div>
        )
});

export default SearchInput;